if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          const idInput = this.form.querySelector('[name=id]');
          if (idInput) idInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      getCartSectionsUrl() {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return root + 'cart';
      }

      getSectionsForAdd() {
        if (typeof window.getCartDrawerSectionNames === 'function') {
          return window.getCartDrawerSectionNames();
        }
        if (this.cart) return 'cart-icon-bubble,cart-drawer';
        return 'cart-icon-bubble';
      }

      replaceCartIconBubble(html) {
        if (!html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source =
          parsed.querySelector('#cart-icon-bubble') ||
          parsed.querySelector('[data-cart-icon-bubble]') ||
          parsed.querySelector('.shopify-section');

        const targets = document.querySelectorAll('#cart-icon-bubble, [data-cart-icon-bubble]');
        if (!source || !targets.length) return;

        const sourceInner = source.querySelector('#cart-icon-bubble') || source;
        targets.forEach((target) => {
          target.innerHTML = sourceInner.innerHTML;
        });
      }

      fetchCartIconBubble() {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const url =
          root +
          '?sections=cart-icon-bubble&sections_url=' +
          encodeURIComponent(window.location.pathname);

        return fetch(url)
          .then((r) => r.json())
          .then((sections) => {
            if (sections['cart-icon-bubble']) {
              this.replaceCartIconBubble(sections['cart-icon-bubble']);
            }
          })
          .catch(() => {});
      }

      syncCartCount() {
        const countSelectors = '.cart-count-bubble span, [data-cart-count], .cart-count';
        const cartUrl =
          window.Shopify && Shopify.routes && Shopify.routes.root
            ? Shopify.routes.root + 'cart.js'
            : '/cart.js';

        return fetch(cartUrl)
          .then((r) => r.json())
          .then((cart) => {
            document.querySelectorAll(countSelectors).forEach((el) => {
              el.textContent = cart.item_count;
            });
            if (cart.item_count > 0) {
              document.querySelectorAll('.cart-count-bubble').forEach((el) => {
                el.classList.remove('visually-hidden');
              });
            }
            if (cart.item_count > 0 && !document.querySelector(countSelectors)) {
              return this.fetchCartIconBubble();
            }
          })
          .catch(() => {});
      }

      updateCartCount(quantity, response) {
        const countSelectors = '.cart-count-bubble span, [data-cart-count], .cart-count';

        document.querySelectorAll(countSelectors).forEach((el) => {
          const current = parseInt(el.textContent, 10) || 0;
          el.textContent = current + quantity;
        });
        document.querySelectorAll('.cart-count-bubble').forEach((el) => {
          el.classList.remove('visually-hidden');
        });

        if (response && response.sections && response.sections['cart-icon-bubble']) {
          this.replaceCartIconBubble(response.sections['cart-icon-bubble']);
        } else {
          this.fetchCartIconBubble();
        }

        return this.syncCartCount();
      }

      clearCartEmptyState() {
        if (!this.cart) return;

        this.cart.classList.remove('is-empty');
        this.cart.querySelectorAll('.drawer__inner-empty').forEach((el) => el.remove());
        this.cart.querySelectorAll('cart-drawer-items').forEach((el) => {
          el.classList.remove('is-empty');
        });

        const checkout = this.cart.querySelector('#CartDrawer-Checkout');
        if (checkout) checkout.removeAttribute('disabled');
      }

      manualUpdateCartDrawer(response) {
        const sectionHtml = response && response.sections && response.sections['cart-drawer'];
        if (!sectionHtml || !this.cart) return false;

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const cartDrawerEl = document.querySelector('#CartDrawer');
        const source = parsed.querySelector('#CartDrawer') || parsed.querySelector('.cart-drawer');

        if (cartDrawerEl && source) {
          cartDrawerEl.innerHTML = source.innerHTML;
        }

        const newCartDrawer = parsed.querySelector('cart-drawer');
        if (newCartDrawer) {
          this.cart.className = newCartDrawer.className;
        }

        this.clearCartEmptyState();
        return true;
      }

      fetchAndRenderCartDrawer() {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const urls = [
          root + '?sections=cart-drawer&sections_url=' + encodeURIComponent(this.getCartSectionsUrl()),
          root + '?sections=cart-drawer&sections_url=' + encodeURIComponent(window.location.pathname),
        ];

        const tryFetch = (index) => {
          if (index >= urls.length) return Promise.resolve();
          return fetch(urls[index])
            .then((r) => r.json())
            .then((sections) => {
              if (sections['cart-drawer']) {
                const payload = { sections };
                if (typeof this.cart.renderContents === 'function') {
                  this.cart.classList.remove('is-empty');
                  this.cart.renderContents(payload);
                } else {
                  this.manualUpdateCartDrawer(payload);
                }
                return;
              }
              return tryFetch(index + 1);
            })
            .catch(() => tryFetch(index + 1));
        };

        return tryFetch(0);
      }

      refreshCartDrawer(response) {
        if (!this.cart) return Promise.resolve();

        this.clearCartEmptyState();

        const hasDrawerSection =
          response &&
          response.sections &&
          response.sections['cart-drawer'];

        if (hasDrawerSection && typeof window.updateCartDrawerFromState === 'function') {
          this.cart.classList.remove('is-empty');
          return window.updateCartDrawerFromState(response, this.cart);
        }

        if (hasDrawerSection) {
          if (typeof this.cart.renderContents === 'function') {
            this.cart.classList.remove('is-empty');
            return Promise.resolve(this.cart.renderContents(response));
          }
          this.manualUpdateCartDrawer(response);
          return Promise.resolve();
        }

        return this.fetchAndRenderCartDrawer();
      }

      openCartDrawer() {
        if (!this.cart) return;

        this.clearCartEmptyState();

        if (this.cart.classList.contains('active')) return;

        if (typeof this.cart.open === 'function') {
          this.cart.open();
          return;
        }

        this.cart.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.getSectionsForAdd());
        formData.append('sections_url', this.getCartSectionsUrl());

        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const quantity = parseInt(this.form.querySelector('[name=quantity]')?.value, 10) || 1;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }

            const finish = () => this.updateCartCount(quantity, response);

            if (this.cart && this.cart.tagName === 'CART-DRAWER') {
              return this.refreshCartDrawer(response).then(() => {
                this.openCartDrawer();
                return finish();
              });
            }

            return finish();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
